const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'android'
  } else if (!window.MSStream && /iPad|iPhone|iPod/.test(ua)) {
    return 'ios'
  }
  return 'desktop'
}

window.mobileDevice = getMobileOS()
window.progressiveWebApp = window.matchMedia(
  '(display-mode: standalone)'
).matches

// Installed PWA: no pinch zoom (text size comes from the OS setting).
// Browsers keep zoom for WCAG 1.4.4. Turbolinks swaps the head, so redo it on every load.
const lockPwaZoom = () => {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (viewport && !viewport.content.includes('user-scalable')) {
    viewport.content += ', maximum-scale=1, user-scalable=no'
  }
}

document.addEventListener('turbolinks:load', () => {
  if (window.progressiveWebApp) {
    document.querySelector('html')?.classList?.add('pwa', window.mobileDevice)
    lockPwaZoom()
  } else {
    document
      .querySelector('html')
      ?.classList?.remove('pwa', window.mobileDevice)
  }
})
